const Emoji_E = {
    ':eat': { id: 208, width: 37, height: 28 },
    ':ee': { id: 209, width: 20, height: 21 },
    ':eek_yello': { id: 211, width: 20, height: 20 },
    ':eek': { id: 210, width: 26, height: 24 },
    ':egg': { id: 212, width: 24, height: 24 },
    ':egypt': { id: 213, width: 31, height: 28 },
    ':eh': { id: 214, width: 20, height: 20 },
    ':elvis': { id: 215, width: 18, height: 22 },
    ':embarrassed': { id: 14, width: 18, height: 18 },
    ':erm': { id: 24, width: 18, height: 18 },
    ':ermm': { id: 216, width: 18, height: 18 },
    ':essen': { id: 217, width: 31, height: 26 },
    ':euro': { id: 218, width: 28, height: 29 },
    ':evil_1': { id: 219, width: 20, height: 20 },
    ':evil_3': { id: 220, width: 18, height: 26 },
    ':evil_4': { id: 221, width: 20, height: 18 },
    ':evil': { id: 222, width: 20, height: 20 },
    ':evilguy': { id: 223, width: 18, height: 18 },
    ':excl': { id: 225, width: 20, height: 20 },
    ':exclamation': { id: 224, width: 20, height: 20 },
    ':expe': { id: 597, width: 18, height: 18 },
    ':eye_red': { id: 226, width: 18, height: 18 },
}

export default Emoji_E
